import SkeletonLoaderRow, {
  SkeletonWrapper,
} from 'components/loading/SkeletonLoaderRow';
import { StyledWrapper } from 'styles/ContainerStyles';
import {
  CardWrapper,
  ChildContentWrapper,
  Column,
} from './SelectParkAndChargeItem';

const ChargerSkeleton = ({ lastElement }: { lastElement?: boolean }) => {
  return (
    <CardWrapper
      isSelected={false}
      lastElement={lastElement}
      testID="charger-skeleton">
      <SkeletonWrapper width={60}>
        <SkeletonLoaderRow height={40} />
      </SkeletonWrapper>
      <ChildContentWrapper>
        <Column>
          <SkeletonWrapper width={60}>
            <StyledWrapper mb={5}>
              <SkeletonLoaderRow height={15} />
            </StyledWrapper>
            <SkeletonLoaderRow height={15} />
          </SkeletonWrapper>
        </Column>
        <SkeletonWrapper width={30}>
          <SkeletonLoaderRow height={30} />
        </SkeletonWrapper>
      </ChildContentWrapper>
    </CardWrapper>
  );
};

export default ChargerSkeleton;
